<template><div><h1>VUX V2.1.0Rc.50 发布日志</h1>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 修复`on-change`事件没有触发 #934 @howyhuang</li>
</ul>
<h2><a href="/zh-CN/components/swipeout.html">Swipeout</a></h2>
<ul><li>[feature] `swipeout`组件`beta`版本</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.50 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.50-201.vue?2cd92d56